import { useMutation } from "react-query"
import api from "../../client"
import { queryClient } from "../../query"
import {UpdateOrderTemplateIsDefaultPayload, UpdateOrderTemplateResponseData } from "../../types/order-template"

const req = async (payload: UpdateOrderTemplateIsDefaultPayload)
    : Promise<UpdateOrderTemplateResponseData> => {
    try {
        const { data } = await api.patch<UpdateOrderTemplateResponseData>(
            `/order-templates/${payload.uuid}`,
            { isDefault: payload.isDefault }
        )

        queryClient.invalidateQueries(["order-templates"], { refetchInactive: true })

        return data
    } catch ({ response: { data } }) {
        return data as UpdateOrderTemplateResponseData
    }
}

export const useOrderTemplateIsDefault = () => {
    return useMutation((payload: UpdateOrderTemplateIsDefaultPayload) => {
        return req(payload)
    })
}
